<template>
  <div class="table-responsive">
    <table class="table table-bordered text-center align-middle">
      <thead class="table-light">
      <tr>
        <th rowspan="2" class="text-start align-middle">Particulars</th>
        <th colspan="3">Contributions</th>
        <th colspan="3">Interest / Profit</th>
        <th rowspan="2" class="align-middle">Grand Total</th>
      </tr>
      <tr>
        <th>Employee</th>
        <th>Employer</th>
        <th>Total</th>
        <th>Employee</th>
        <th>Employer</th>
        <th>Total</th>
      </tr>
      </thead>

      <tbody>
      <tr>
        <td class="text-start fw-bold">Opening Balance</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'employee_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'employer_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'contribution_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'employee_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'employer_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'interest_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'opening_balance', 'grand_total') }}</td>
      </tr>
      <tr>
        <td class="text-start">Contribution During the Period</td>
        <td class="text-right">{{ getAmount(providentFundData, 'contribution', 'employee') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'contribution', 'employer') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'contribution', 'employee_total') }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">{{ getAmount(providentFundData, 'contribution', 'employee_total') }}</td>
      </tr>
      <tr>
        <td class="text-start">Interest / Profit During the Period</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">{{ getAmount(providentFundData, 'interest', 'employee') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'interest', 'employer') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'interest', 'employee_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'interest', 'employee_total') }}</td>
      </tr>
      <tr>
        <td class="text-start">Adjustment During the Period</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'employee_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'employer_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'contribution_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'employee_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'employer_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'interest_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'adjustment', 'grand_total') }}</td>
      </tr>
      <tr class="fw-bold">
        <td class="text-start">Closing Balance</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'employee_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'employer_contribution') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'contribution_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'employee_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'employer_interest') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'interest_total') }}</td>
        <td class="text-right">{{ getAmount(providentFundData, 'closing_balance', 'grand_total') }}</td>
      </tr>
      </tbody>
    </table>

  </div>
</template>

<script setup>

const props  = defineProps({
  providentFundData     : Object,
});

const getAmount = (data, section, field) => {
  if (!data) return 0;
  if (!data[section]) return 0;
  if (data[section][field] === undefined || data[section][field] === null) return 0;
  return data[section][field];
}
</script>
